import React, { Component, Fragment } from "react";
import _ from "lodash";
import { ParallaxProvider } from "react-skrollr";
import { Element } from "react-scroll";
import { Header, Footer } from "../../components";
import { Helmet } from "react-helmet";
import { withRedux } from "../../hoc";
import { switchLanguage } from "../../actions/language";
import { switchLocation } from "../../actions/location";
import { initAppPhuketDusitDeluxePoolVilla } from "../../actions/phuket-dusit-deluxe-pool-villa";
import { assetsPath } from "../../utils";
import Gallery from "./Gallery";
import Concept from "./Concept";
import Faq from "./Faq";
import Destination from "./Destination";
import TheSanctuaryclub from "./TheSanctuaryclub";
import Siteplan from "./Siteplan";
import Masterplan from "./Masterplan";
import Residences from "./Residences";
import Ebrochure from "./Ebrochure";

const page = "phuket-dusit-deluxe-pool-villa";

const sections = [
  { key: "gallery", label: "Gallery" },
  { key: "concept", label: "Concept" },
  { key: "masterplan", label: "Master Plan" },
  { key: "siteplan", label: "Site Plan" },
  { key: "residences", label: "Residences" },
  { key: "destination", label: "Destination" },
  { key: "sanctuary-club", label: "The Santuary Club" },
  { key: "faq", label: "FAQ", hideOnMobile: true },
  { key: "e-brochure", label: "E-Brochure", hideOnMobile: true },
];

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};

const actionToProps = {
  switchLanguage,
  switchLocation,
  initAppPhuketDusitDeluxePoolVilla,
};

@withRedux(mapStateToProps, actionToProps)
export default class PhuketDusitDeluxePoolVilla extends Component {
  constructor(props) {
    super(props);
    this.headerRef = React.createRef();
  }
  componentDidMount() {
    this.setLanguage(this.props.match.params.language);
    this.setLocation(this.props.route.key);
    this.fetchData();
  }
  componentDidUpdate(prevProps) {
    const currentLanguage = prevProps.match.params.language;
    const nextLanguage = this.props.match.params.language;
    if (currentLanguage !== nextLanguage) {
      this.setLanguage(nextLanguage);
    }
  }

  handleWheel = (evt) => {
    if (evt.deltaY > 0) {
      const atBottomOfSection = this.headerRef.current.atBottomOfSection();
      if (atBottomOfSection) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.returnValue = false;
        // console.log('evt', evt.deltaY);
        this.headerRef.current.handleScrollDown();
      }
    }

    if (evt.deltaY < 0) {
      const atTopOfSection = this.headerRef.current.atTopOfSection();
      if (atTopOfSection) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.returnValue = false;
        // console.log('evt', evt.deltaY);
        this.headerRef.current.handleScrollUp();
      }
    }
  };

  setLanguage = (language) => {
    this.props.actions.switchLanguage(language);
  };
  setLocation = (location) => {
    this.props.actions.switchLocation(location);
  };
  fetchData = () => {
    this.props.actions.initAppPhuketDusitDeluxePoolVilla();
  };
  renderSectionWithId = (component, id) => {
    return (
      <Element name={id}>
        <section id={id}>{component}</section>
      </Element>
    );
  };
  render() {
    const pageData = _.get(this.props, `${page}.data`);
    const isMobile = _.get(this.props, "device.isMobile");
    const currentLanguage = _.get(this.props, "language.currentActive");
    console.log("pageData-Dusit", { page, pageData });
    return (
      <ParallaxProvider
        init={{
          smoothScrollingDuration: 100,
          smoothScrolling: true,
          forceHeight: false,
        }}
      >
        <Fragment>
          <Helmet>
            <title>Dusit Laguna Resort Villas Phuket</title>
          </Helmet>
          <Header
            mainLogo={`${assetsPath()}/images/logo-laguna-property.svg`}
            subLogo={`${assetsPath(page)}/images/logo/logo.png`}
            language={currentLanguage}
            projectSections={sections}
            wrappedComponentRef={this.headerRef}
          />
          <div
            className={`main-content ${page}-page`}
            DISABLE_onWheel={this.handleWheel}
          >
            {/* <ButtonScrollToSection /> */}
            {this.renderSectionWithId(
              <Gallery {..._.get(pageData, `gallery`)} page={page} />,
              "gallery"
            )}
            {this.renderSectionWithId(
              <Concept
                imageSlider={_.get(pageData, "concept.imageSlider")}
                content={_.get(pageData, "concept.content")}
                page={page}
              />,
              "concept"
            )}
            {this.renderSectionWithId(
              <Masterplan
                map={_.get(pageData, "masterPlan.maps")}
                page={page}
              />,
              "masterplan"
            )}
            {this.renderSectionWithId(
              <Siteplan
                map={_.get(pageData, "sitePlan.maps")}
                dataSitePlan={_.get(pageData, "sitePlan.type")}
                page={page}
              />,
              "siteplan"
            )}
            {this.renderSectionWithId(
              <Residences
                landingPage={_.get(pageData, "residence.landingPage")}
                type={_.get(pageData, "residence.type")}
                page={page}
              />,
              "residences"
            )}
            {this.renderSectionWithId(
              <Destination
                isMobile={isMobile}
                imageSlider={_.get(pageData, "destination.landingPage")}
                title={_.get(pageData, "destination.content.title")}
                description={_.get(pageData, "destination.content.description")}
                mapData={_.get(pageData, "destination.map")}
                page={page}
              />,
              "destination"
            )}
            {this.renderSectionWithId(
              <TheSanctuaryclub
                description={_.get(pageData, "sanctuaryClub.description")}
                image={_.get(pageData, "sanctuaryClub.image")}
                title={_.get(pageData, "sanctuaryClub.title")}
                page={page}
              />,
              "sanctuary-club"
            )}
            {this.renderSectionWithId(
              <Faq
                {...require("../../data/PhuketDusitDeluxePoolVilla/faq")}
                page={page}
              />,
              "faq"
            )}
            {this.renderSectionWithId(
              <Fragment>
                <Ebrochure
                  location="phuket"
                  project="dusit-deluxe-pool-villa"
                  page={page}
                />
                <Footer />
              </Fragment>,
              "e-brochure"
            )}
          </div>
        </Fragment>
      </ParallaxProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PhuketDusitDeluxePoolVilla/index.js